import React, { useState } from 'react';
import _cloneDeep from 'lodash/cloneDeep';

import Table from 'components/customTable';
import JobList from 'components/jobs/list';

import PieChart from '../../../components/pieChart';
import ZpFilter from '../../../components/zpFilter';
import { CAROUSEL_FILTERS,FILTER_PARAMS } from '../../../components/zpFilter/filterUtils';
import CommonService from '../../../services/commonService';
import { CMP_SUBPAGES,JOB_BUCKET_GROUP } from '../../../utils/constant';
const colorSchemes = ['GREEN', 'BLUE', 'PURPLE'];

const GenderEthnicLanguageDiversity = ({
  jobTitle,
  jobTitlePlural,
  pieChartData,
  genderSetionContentBlurb,
  mostCommonDegreesContentBlurb,
  ethnicitySetionContentBlurb,
  foreignLanguageContentBlurb,
  filterValueRange,
  filterLogEventCallback,
  jobsIndex,
  locations,
  jobListDismiss,
  noTitle,
}) => {
  const [titlePieChartData, setChartData] = useState(_cloneDeep(pieChartData));
  const [currentJobTitle, setCurrentJobTitle] = useState({
    genders: jobTitle,
    ethnicities: jobTitle,
    degree: jobTitle,
  });

  const renderContentBlurb = (key) => {
    let content = '';
    switch (key) {
      case 'genders':
        content = genderSetionContentBlurb && genderSetionContentBlurb.content;
        break;
      case 'ethnicities':
        content = ethnicitySetionContentBlurb && ethnicitySetionContentBlurb.content;
        break;
      case 'degree':
        content = mostCommonDegreesContentBlurb && mostCommonDegreesContentBlurb.content;
        break;
      default:
        content = foreignLanguageContentBlurb && foreignLanguageContentBlurb.content;
        break;
    }
    return content ? <div dangerouslySetInnerHTML={{ __html: content }} /> : null;
  };

  const getPieChartColorScheme = (key) => {
    switch (key) {
      case 'ethnicities':
        return colorSchemes[0];
      case 'degree':
        return colorSchemes[1];
      case 'languages':
        return colorSchemes[2];
      default:
        return colorSchemes[0];
    }
  };

  const handleFilterUpdate = async (key, { value }) => {
    let copyChartData = [...titlePieChartData];

    const idx = copyChartData.findIndex((chartData) => chartData.key === key);

    if (value === jobTitle) {
      return;
    }

    if (value === undefined) {
      copyChartData[idx].chartData = pieChartData[idx].chartData;
      setChartData(copyChartData);
      return;
    }

    const data = { key, jobTitle: value.originalSearch ? value.originalSearch : value };
    setCurrentJobTitle({
      ...currentJobTitle,
      [key]: value.originalSearch ? value.originalSearch : value,
    });

    try {
      const fetchService =
        key === 'degree'
          ? CommonService.fetchMostCommonDegreesPieChartData
          : CommonService.fetchDiversityPieChartData;

      const chartData = await fetchService(data);
      copyChartData[idx].chartData = chartData;
      setChartData(copyChartData);
    } catch (error) {
      console.log(error);
    }
  };

  const [selectedFilterValues, setSelectedFilterValues] = useState({});
  const filterProps = (key) => {
    const filterGroup = `${JOB_BUCKET_GROUP.CAREER_DEMOGRAPHICS_COMPARE_GENDER_ETHIC_LANGUAGE}-${key}`;
    return {
      ...CAROUSEL_FILTERS[FILTER_PARAMS.JOB_TITLE],
      valueRange: filterValueRange,
      onApply: (_, data) => {
        setSelectedFilterValues({ ...selectedFilterValues, [key]: data });
        handleFilterUpdate(key, data);
      },
      onClear: (_, data) => {
        setSelectedFilterValues({ ...selectedFilterValues, [key]: data });
        handleFilterUpdate(key, data);
      },
      options: {
        logEvent: () => filterLogEventCallback(filterGroup),
      },
    };
  };

  const getTableColumns = (key) => {
    const data = titlePieChartData.find((x) => x.key === key);
    if (!data) return {};
    let columns = {
      name: {
        columnName: 'Name',
      },
      percentDisplay: {
        customeWidth: '50%',
        columnName: 'Percentages',
        customSortByField: 'percent',
      },
    };

    switch (key) {
      case 'ethnicities':
        columns.name.columnName = currentJobTitle[key] + ' Race';
        break;
      case 'languages':
        columns.name.columnName = 'Foreign Language';
        break;
      case 'degree':
        columns.name.columnName = currentJobTitle[key] + ' Degree';
        break;
      default:
        columns.name.columnName = data.title;
        break;
    }

    return columns;
  };

  const getTableTitle = (key) => {
    const titlesMapWithKey = {
      ethnicities: (
        <h3 className="zp-title-h3 text-capitalize z-mt-48 z-mb-24">{`${jobTitle} Race`}</h3>
      ),
      languages: (
        <h3 className="zp-title-h3 text-capitalize z-mt-48 z-mb-24">{`${jobTitle} Languages Spoken`}</h3>
      ),
      degree: jobTitlePlural && (
        <h3 className="zp-title-h3 text-capitalize z-mt-48 z-mb-24">{`${jobTitlePlural} By Education`}</h3>
      ),
      genders: jobTitlePlural && (
        <h3 className="zp-title-h3 text-capitalize z-mt-48 z-mb-24">{`${jobTitlePlural} By Gender`}</h3>
      ),
    };

    return titlesMapWithKey[key];
  };

  return (
    <div className="d-flex flex-column diversity-container">
      {titlePieChartData
        .filter(({ showPieChart }) => showPieChart)
        .map(({ title, chartData, key }, idx) => {
          const tableData = chartData.map((d) => ({
            ...d,
            percentDisplay: (d?.percent ?? 0) + '%',
          }));

          return (
            <React.Fragment key={key}>
              <div className={!noTitle ? 'diversity' : 'mt-0 diversity'} id={`diversity-${key}`}>
                {!noTitle && <h3 className="cmpSectionh4 mb-3">{title}</h3>}
                {renderContentBlurb(key)}
                <div className="mt-4">
                  <ZpFilter
                    {...filterProps(key)}
                    controlledValues={
                      selectedFilterValues[key] ? selectedFilterValues[key] : undefined
                    }
                  />
                </div>
                <div className="chart">
                  <PieChart
                    pieChartDiameter={160}
                    pieChartData={chartData}
                    colorScheme={getPieChartColorScheme(key)}
                    hideGraphOnMobile={false}
                  />
                </div>
                <div className="mt-2">
                  <Table
                    columnConfig={getTableColumns(key)}
                    bodyData={tableData}
                    defaultRowsDisplay={99}
                    tableHeaderTitleContent={getTableTitle(key)}
                  />
                </div>
              </div>
              {!jobListDismiss && key === 'degree' && (
                <div className="job-list-placeholder d-flex d-lg-none">
                  <JobList
                    title={`${jobTitle} Jobs You Might Like`}
                    jobsPageIndexable={jobsIndex}
                    origin={CMP_SUBPAGES.DEMOGRAPHICS}
                    initialPayload={{
                      title: jobTitle,
                      locations,
                    }}
                    usingPaidAPI={true} // It will use paid job API everytime
                  />
                </div>
              )}
            </React.Fragment>
          );
        })}
    </div>
  );
};

export default GenderEthnicLanguageDiversity;
